import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Button, Box } from '@mui/material';
import CommonImages from '../../../commons/images';
import useAppLocation from '../../../store/models/env/useAppLocation';
import * as styles from './styles';

function TopBar({ subscriber, onSignIn, onManage, onHome }) {
    const [scrolled, setScrolled] = useState(false);
    const { isManagePage } = useAppLocation();

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 64);
        handleScroll();
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    function renderNavButton() {
        if (isManagePage) return null;
        if (subscriber) {
            return (
                <Button variant="contained" onClick={onManage} sx={styles.navButton}>
                    <Box component="span" sx={styles.navLabelFull}>Manage My ECAL</Box>
                    <Box component="span" sx={styles.navLabelShort}>My ECAL</Box>
                </Button>
            );
        }
        return (
            <Button variant="outlined" onClick={onSignIn} sx={styles.navButton}>
                Sign In
            </Button>
        );
    }

    return (
        <AppBar position="sticky" sx={styles.appBar(scrolled)}>
            <Toolbar sx={styles.toolbar}>

                <Box component="button" onClick={onHome} aria-label="ECAL World — home" sx={styles.logoButton}>
                    <Box component="img" src={CommonImages.ECAL_LOGO} alt="ECAL World" sx={styles.logoFull(scrolled)} />
                    <Box component="img" src={CommonImages.ECAL_SYMBOL} alt="" aria-hidden="true" sx={styles.logoSymbol(scrolled)} />
                </Box>

                <Box sx={styles.nav}>
                    {renderNavButton()}
                </Box>

            </Toolbar>
        </AppBar>
    );
}

export default TopBar;
